import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';

import type { Runtime } from '@xing-com/crate-xinglet/internal';

// NOTE: importing the fragment type here violates some settings, but we want to
// have them in the repo root
/* eslint-disable  */
// @ts-ignore
import possibleTypes from '../../../fragment-types.json';
/* eslint-enable */

export function createApolloClient(runtime: Runtime): ApolloClient<unknown> {
  const { loginState } = runtime.config;
  const allowDataFetching = !runtime.isServer || loginState === 'LOGGED_OUT';
  const { APOLLO_STATE: state } = runtime.serverData;

  const cache = new InMemoryCache({ possibleTypes });

  if (state) cache.restore({ ...state });

  const client = new ApolloClient({
    cache,
    connectToDevTools: runtime.host.isPreview,
    link: new HttpLink({
      fetch: async (...args) => {
        if (!allowDataFetching) {
          throw new Error('Data fetching is not allowed!');
        }

        return runtime.fetch(...args);
      },
      uri: runtime.config.xingOneEndpoint,
    }),
    ssrMode: runtime.isServer,
  });

  if (runtime.isServer) {
    runtime.events.once('server-rendered', () => {
      runtime.serverData['APOLLO_STATE'] = cache.extract();
    });
  }

  return client;
}
